// extracted by mini-css-extract-plugin
export default {"wrap":"ygil1eZEmeMkovGCxCBn","main":"Y7f_la5iZVHanERiWRgy","group":"URcDQRv37xpcmLXxhxv1"};